<ngx-loading-bar
  #loading
  color="#3AA36B"
  includeSpinner="false"
  height="3px"
></ngx-loading-bar>

<div id="service-providers-new">
  <app-new [title]="title" [subtitle]="subtitle" [urlBack]="urlBack">
    <div class="container" [formGroup]="newServiceProvider">
      <div class="row">
        <div class="col">
          <label>
            <span>RAZÃO SOCIAL</span>

            <input
              type="text"
              maxlength="50"
              placeholder="Nome da empresa"
              formControlName="nmRazaoSocial"
            />
          </label>
        </div>

        <div class="col">
          <label>
            <span>CNPJ</span>

            <input
              type="text"
              placeholder="Número do CNPJ"
              formControlName="nrCnpj"
              mask="{{ maskCnpj }}"
            />
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>
            <span>NOME FANTASIA</span>

            <input
              type="text"
              maxlength="50"
              placeholder="Nome fantasia da empresa"
              formControlName="nmFantasia"
            />
          </label>
        </div>

        <div class="col">
          <label>
            <span>INSCRIÇÃO ESTADUAL</span>

            <input
              type="text"
              placeholder="Inscrição estadual registrada a empresa"
              formControlName="nrInscrEstadual"
            />
          </label>
        </div>
      </div>

      <app-regions-states
        [selectedRegions]="selectedRegions"
        [selectedStates]="selectedStates"
        (regions)="regionsValues($event)"
        (states)="statesValues($event)"
      ></app-regions-states>

      <div class="row">
        <div class="col">
          <label>
            <span>CÓDIGO SAP</span>

            <input
              type="text"
              placeholder="Código SAP do prestador de serviço"
              formControlName="cdFornecedorSap"
            />
          </label>
        </div>

        <div class="col">
          <label>
            <span>TIPO DE SERVIÇO</span>

            <app-checkbox
              [checkboxActive]="checkboxActive"
              (values)="serviceValues($event)"
            ></app-checkbox>
          </label>
        </div>
      </div>

      <app-maintenance-equipments
        [relationships]="relationships"
        (relationshipsOutput)="relationshipsValues($event)"
      ></app-maintenance-equipments>

      <div class="row">
        <div class="col">
          <button (click)="addNewServiceProvider()">
            CADASTRAR PRESTADOR DE SERVIÇO
          </button>
        </div>
      </div>
    </div>
  </app-new>
</div>
